import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const OutsideIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-outside"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="m28.096 11.313 1.114 1.66a33 33 0 0 0-2.816 2.113c-3.104 2.611-5.156 5.39-6.366 8.156a14.4 14.4 0 0 0-.877 2.625l-.066.314-.045.258-.029.199-.013.138-1.996-.123c.055-.886.382-2.356 1.194-4.212 1.331-3.044 3.568-6.074 6.91-8.885q1.105-.93 2.355-1.808z"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M19 7.286V34h-2V7.286z"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M7.904 11.313a35 35 0 0 1 2.989 2.243c3.343 2.81 5.58 5.84 6.91 8.884.765 1.748 1.1 3.152 1.182 4.05l.013.163-1.996.123-.014-.138-.049-.321-.055-.286-.035-.164a14.4 14.4 0 0 0-.877-2.625c-1.21-2.766-3.262-5.545-6.366-8.156a32 32 0 0 0-2.218-1.701l-.599-.411z"
        />
        <path
          fill="#0050b3"
          className={styles.interactiveColor}
          d="M28.718 8.265c.092-.356.157-.723.157-1.107 0-2.47-2.029-4.474-4.53-4.474-.735 0-1.417.188-2.03.493A4.51 4.51 0 0 0 18 0a4.51 4.51 0 0 0-4.315 3.177 4.5 4.5 0 0 0-2.029-.493c-2.502 0-4.53 2.003-4.53 4.474 0 .384.063.751.156 1.107C5.09 8.841 3.5 10.53 3.5 12.526 3.5 14.997 5.934 17 8.937 17c1.523 0 2.897-.517 3.884-1.346 1.316.83 3.15 1.346 5.18 1.346s3.861-.517 5.177-1.346c.987.83 2.362 1.346 3.884 1.346 3.003 0 5.438-2.003 5.438-4.474 0-1.996-1.589-3.685-3.782-4.26"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="m60.096 11.313 1.114 1.66a33 33 0 0 0-2.816 2.113c-3.104 2.611-5.156 5.39-6.366 8.156a14.4 14.4 0 0 0-.877 2.625l-.066.314-.045.258-.029.199-.013.138-1.996-.123c.055-.886.382-2.356 1.194-4.212 1.331-3.044 3.568-6.074 6.91-8.885q1.105-.93 2.355-1.808z"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M51 7.286V34h-2V7.286z"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M39.904 11.313a35 35 0 0 1 2.989 2.243c3.343 2.81 5.58 5.84 6.91 8.884.765 1.748 1.1 3.152 1.182 4.05l.013.163-1.996.123-.014-.138-.049-.321-.055-.286-.035-.164a14.4 14.4 0 0 0-.877-2.625c-1.21-2.766-3.262-5.545-6.366-8.156a32 32 0 0 0-2.218-1.701l-.599-.411z"
        />
        <path
          fill="#0050b3"
          className={styles.interactiveColor}
          d="M60.718 8.265c.092-.356.157-.723.157-1.107 0-2.47-2.029-4.474-4.53-4.474-.735 0-1.417.188-2.03.493A4.51 4.51 0 0 0 50 0a4.51 4.51 0 0 0-4.315 3.177 4.5 4.5 0 0 0-2.029-.493c-2.502 0-4.53 2.003-4.53 4.474 0 .384.063.751.156 1.107-2.193.576-3.782 2.265-3.782 4.261 0 2.471 2.434 4.474 5.437 4.474 1.523 0 2.897-.517 3.884-1.346 1.316.83 3.15 1.346 5.18 1.346s3.861-.517 5.177-1.346c.987.83 2.362 1.346 3.884 1.346 3.003 0 5.438-2.003 5.438-4.474 0-1.996-1.589-3.685-3.782-4.26"
        />
        <path
          fill="#fff"
          className={styles.white}
          d="M42.5 27.5h-17a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h17a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M42.5 23h-17a1.5 1.5 0 0 0-1.5 1.5v2a1.5 1.5 0 0 0 1.5 1.5h17a1.5 1.5 0 0 0 1.5-1.5v-2a1.5 1.5 0 0 0-1.5-1.5m-17 1h17a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-17a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5"
        />
        <path
          fill="#fff"
          className={styles.white}
          d="M42.5 31.5h-17a1 1 0 0 1 0-2h17a1 1 0 0 1 0 2"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M42.5 29h-17a1.5 1.5 0 0 0-1.5 1.5l.008.145c.09.782.729 1.355 1.492 1.355h17a1.5 1.5 0 0 0 1.5-1.5l-.008-.145A1.507 1.507 0 0 0 42.5 29m-17 1h17a.5.5 0 0 1 .497.441l.004.088c-.001.247-.225.471-.501.471h-17a.5.5 0 0 1-.497-.441L25 30.47c.001-.247.225-.471.501-.471M27 32v2h-1v-2zM42 32v2h-1v-2z"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M40 28v2h-1v-2zM29 28v2h-1v-2z"
        />
      </g>
    </Icon>
  )
}
